import React, { useEffect, useState } from 'react';
import './Loader.css';

function Loader({ size = 'md' }) {
  return (
    <div className="loader">
      <div className={`loader__spinner loader__spinner--${size}`}></div>
    </div>
  );
}

export function SyncOverlay({ visible, onHide }) {
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!visible) {
      setDone(false);
      return;
    }
    const t1 = setTimeout(() => setDone(true), 2500);
    const t2 = setTimeout(() => onHide?.(), 4300);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [visible, onHide]);

  if (!visible) return null;

  return (
    <div className="sync-overlay">
      {!done ? (
        <div className="sync-loading">
          <div className="loader__spinner loader__spinner--lg"></div>
          <span className="sync-text">Syncing data…</span>
        </div>
      ) : (
        <div className="sync-complete">
          <div className="sync-check-wrap">
            <i className="fas fa-check"></i>
          </div>
          <span className="sync-text">Data sync complete</span>
        </div>
      )}
    </div>
  );
}

export default Loader;
